export const firebaseConfig = {
    apiKey: "AIzaSyDiosorZ5G11D562iPkXecEQimpBOgESZM",
    publicKey: "BLWQNA9M6l25Ej5oT_mlaL1cOFUFVHFLJmiMogtSVKQC8_N_IUiXjRBa6g_jCLFHNzM1C42-RnC7TRt3nLljVA0",
    authDomain: "experium-notify.firebaseapp.com",
    databaseURL: "https://experium-notify.firebaseio.com",
    storageBucket: "experium-notify.appspot.com",
    messagingSenderId: "542232852288",
    appId: "1:542232852288:web:b918b28d4d0b5debc96ca5",
    projectId: "experium-notify",
};

export const FIREBASE_PERMISSION_ERROR = 'messaging/permission-blocked';
